import { Component, Input } from '@angular/core'

@Component({
  selector: 'mmx-eligibility-benefit-details',
  templateUrl: './eligibility-benefit-details.component.html',
  standalone: false,
})
export class EligibilityBenefitDetailsComponent {
  @Input() benefit: any
  @Input() planStartDate?: string
  @Input() planEndDate?: string

  // Only surface the benefit-level coverage dates when they differ from the
  // plan-level dates, which already display the shared coverage period.
  get showCoverageStartDate(): boolean {
    return !!this.benefit?.coverage_start_date && this.benefit.coverage_start_date !== this.planStartDate
  }

  get showCoverageEndDate(): boolean {
    return !!this.benefit?.coverage_end_date && this.benefit.coverage_end_date !== this.planEndDate
  }
}
